import { render, staticRenderFns } from "./a404.vue?vue&type=template&id=47ce4933&scoped=true"
import script from "./a404.vue?vue&type=script&lang=js"
export * from "./a404.vue?vue&type=script&lang=js"
import style0 from "./a404.vue?vue&type=style&index=0&id=47ce4933&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47ce4933",
  null
  
)

export default component.exports